import { TemplateForSelection } from 'api/TemplatePickerAPI';
import { FetchTemplatesProps, TemplateWithDetails } from '../types';
import * as t from './actionTypes';

export const fetchTemplates = ({
  filter,
  messageMedium,
  orderBy,
  page,
  pageSize,
  placementId,
  queryString,
  sorting,
  templateType,
  whatsAppTemplateType,
}: FetchTemplatesProps) => ({
  type: t.FETCH_TEMPLATES_REQUEST,
  filter,
  messageMedium,
  orderBy,
  page,
  pageSize,
  placementId,
  queryString,
  sorting,
  templateType,
  whatsAppTemplateType,
});

export const fetchTemplatesResponse = (
  templatesById: { [key: number]: TemplateForSelection },
  query: string,
  templatesIds: number[],
  total: any,
) => ({
  type: t.FETCH_TEMPLATES_RESPONSE,
  templatesById,
  query,
  templatesIds,
  total,
});

// CREATE TEMPLATE
export const createTemplate = (campaignId: number, messageMedium: string) => ({
  type: t.CREATE_TEMPLATE_REQUEST,
  messageMedium,
  campaignId,
});

export const createTemplateResponse = () => ({
  type: t.CREATE_TEMPLATE_RESPONSE,
});

export const createBeeTemplate = (campaignId: number, messageMedium: string, slug: string) => ({
  type: t.CREATE_BEE_TEMPLATE_REQUEST,
  messageMedium,
  campaignId,
  slug,
});

export const createBeeTemplateResponse = () => ({
  type: t.CREATE_BEE_TEMPLATE_RESPONSE,
});

export const importTemplate = (
  campaignId: number | undefined,
  template: File | string,
  onSuccess?: (templateId?: string) => void,
) => ({
  type: t.IMPORT_TEMPLATE_REQUEST,
  campaignId,
  template,
  onSuccess,
});

export const importTemplateResponse = () => ({
  type: t.IMPORT_TEMPLATE_RESPONSE,
});

export const cloneTemplate = (templateId: number, campaignId: number) => ({
  type: t.CLONE_TEMPLATE_REQUEST,
  templateId,
  campaignId,
});

export const cloneTemplateResponse = () => ({
  type: t.CLONE_TEMPLATE_RESPONSE,
});

export const cloneTemplateError = () => ({
  type: t.CLONE_TEMPLATE_ERROR,
});

export const fetchTemplateDetails = (templateId: number, messageMedium: string) => ({
  type: t.FETCH_TEMPLATE_DETAILS_REQUEST,
  templateId,
  messageMedium,
});

export const fetchTemplateDetailsResponse = (
  templateId: number,
  templateDetails: TemplateWithDetails,
) => ({
  type: t.FETCH_TEMPLATE_DETAILS_RESPONSE,
  templateDetails,
  templateId,
});

export const fetchSenders = () => ({
  type: t.FETCH_SENDERS_REQUEST,
});

export const fetchSendersResponse = (smsSenders: any[], authedEmails: any[]) => ({
  type: t.FETCH_SENDERS_RESPONSE,
  smsSenders,
  authedEmails,
});

export const fetchSendersError = () => ({
  type: t.FETCH_SENDERS_ERROR,
});

export const fetchCampaignDetails = (campaignId: number) => ({
  type: t.FETCH_CAMPAIGN_DETAILS_REQUEST,
  campaignId,
});

export const fetchCampaignDetailsResponse = (campaign: any) => ({
  type: t.FETCH_CAMPAIGN_DETAILS_RESPONSE,
  campaign,
});

export const fetchCampaignDetailsError = () => ({
  type: t.FETCH_CAMPAIGN_DETAILS_ERROR,
});

export const copyTemplateToCampaign = (
  campaignId: number,
  templateId: number,
  dataFeedId?: number,
) => ({
  type: t.COPY_TEMPLATE_TO_CAMPAIGN_REQUEST,
  campaignId,
  templateId,
  dataFeedId,
});

export const copyTemplateToCampaignResponse = () => ({
  type: t.COPY_TEMPLATE_TO_CAMPAIGN_RESPONSE,
});

export const copyTemplateToCampaignError = () => ({
  type: t.COPY_TEMPLATE_TO_CAMPAIGN_ERROR,
});

export const fetchDataFeeds = () => ({
  type: t.FETCH_DATA_FEEDS_REQUEST,
});

export const fetchDataFeedsResponse = (dataFeeds: unknown[]) => ({
  type: t.FETCH_DATA_FEEDS_RESPONSE,
  dataFeeds,
});

export const fetchDataFeedsError = () => ({
  type: t.FETCH_DATA_FEEDS_ERROR,
});

export const fetchMemberData = (memberIds: string[]) => ({
  type: t.FETCH_MEMBER_DATA_REQUEST,
  memberIds,
});

export const fetchMemberDataResponse = (membersById: any) => ({
  type: t.FETCH_MEMBER_DATA_RESPONSE,
  membersById,
});

export const fetchMemberDataError = () => ({
  type: t.FETCH_MEMBER_DATA_ERROR,
});
